import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';

import { ContentSkeleton } from './subcomponents/Skeletons';
import { emtContentDataModel } from './dataModels';
import { propTypesEmtQuestionsAndAnswers } from './QuestionsAndAnswers/constants';

const ssr = typeof window === 'undefined';

let ServerImport = null;

const ImportedComponent = withDynamicImport({
  server: async () => {
    ServerImport = (await import('./QuestionsAndAnswers/EmtQuestionsAndAnswers')).EmtQuestionsAndAnswersComponent;
  },
  client: () => import('./QuestionsAndAnswers/EmtQuestionsAndAnswers'),
  placeholder: (<ContentSkeleton />),
  name: 'EmtQuestionsAndAnswersComponent',
});

const HydratedEmtQuestionsAndAnswers = withHydrator({
  id: 'emt-questions-and-answers',
  scrollBuffer: 750,
  delay: 2000,
  preserveCtxVal: 'clientStore',
  placeholder: (<ContentSkeleton />)
}, ImportedComponent);

const DynamicEmQuestionsAndAnswers = withDynamicComponent(HydratedEmtQuestionsAndAnswers);
export const EmtQuestionsAndAnswersImporter = withErrorBoundary(ssr ? (props) => <ServerImport {...props} /> : DynamicEmQuestionsAndAnswers);

EmtQuestionsAndAnswersImporter.displayName = 'EmtQuestionsAndAnswersImporter';
EmtQuestionsAndAnswersImporter.dataModel = emtContentDataModel;
EmtQuestionsAndAnswersImporter.propTypes = propTypesEmtQuestionsAndAnswers;